import { render, staticRenderFns } from "./UpgradeNavTabs.vue?vue&type=template&id=96b344c6&scoped=true"
import script from "./UpgradeNavTabs.vue?vue&type=script&lang=js"
export * from "./UpgradeNavTabs.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNavTabs.vue?vue&type=style&index=0&id=96b344c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b344c6",
  null
  
)

export default component.exports